'use strict'
exports.__esModule = true
exports.default = _default
var _arr = require('../arr')
var _num = require('../num')
var _str = require('../str')
var _obj = require('../obj')
var _func = require('../func')

/**
 * cast
 *
 *
 * @param {*} val
 * @param {('string' | 'number' | 'boolean' | 'object' | 'array' | 'null' | 'function')} type
 * @returns {*}
 */

function _default(val, type) {
  switch (type) {
    case 'string':
      return (0, _str.castStr)(val)
    case 'number':
      return (0, _num.castNum)(val)
    case 'boolean':
      return !!val
    case 'object':
      return (0, _obj.castObj)(val)
    case 'array':
      return (0, _arr.castArr)(val)
    case 'function':
      return (0, _func.castFunc)(val)
    default:
      return val
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/misc/cast.js
// module id = 638
// module chunks = 0